module.exports = __webpack_public_path__ + "img/logo-vinagame.603353fd.png";